
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34365',
  depVersions: {
  "documents-public-ui": "static-1.34365",
  "client-types": "static-1.459",
  "documents-lib": "static-1.34370",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2074",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5537",
  "hs-test-utils": "static-1.7959",
  "hub-http": "static-1.6164",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11403",
  "I18n": "static-7.1610",
  "jasmine-immutable": "static-1.2963",
  "jasmine-runner": "static-1.6413",
  "lodash": "static-1.3",
  "quartz": "static-1.6943",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16606",
  "reporting-data": "static-1.67259",
  "reporting-testing-lib": "static-1.9192",
  "reporting-visualizations": "static-1.59335",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4714",
  "webpack-env": "static-1.54",
  "atom": "static-1.5016",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2440",
  "classnames": "static-2.10",
  "cssUtils": "static-1.778",
  "customer-data-filters-ui": "static-1.39546",
  "customer-data-objects": "static-1.7604",
  "customer-data-property-utils": "static-1.8027",
  "data-fetching-client": "static-1.9618",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4467",
  "flux-actions": "static-1.329",
  "FormsCommonComponents": "static-1.85676",
  "FormUrlGenerator": "static-2.4664",
  "foundations-components": "static-1.7814",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11711",
  "icons": "static-2.643",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7103",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3792",
  "property-translator": "static-1.5347",
  "quartz-config": "static-1.721",
  "quartz-core": "static-1.6162",
  "quick-fetch": "static-1.3870",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5297",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8114",
  "reference-resolvers-lite": "static-1.8037",
  "report-customization-components": "static-1.12973",
  "reporting-enablement": "static-1.22690",
  "reporting-reports": "static-1.66937",
  "reporting-snowflake": "static-1.55877",
  "reporting-ui-components": "static-2.64530",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4590",
  "sales-content-partitioning": "static-1.8880",
  "SalesContentIndexUI": "static-3.9155",
  "sanitize": "static-1.4417",
  "sanitize-text": "static-1.8087",
  "self-service-api": "static-1.10190",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1689",
  "signup-constants": "static-1.18737",
  "signup-ui-lego-core": "static-1.20747",
  "signup-ui-url-generator": "static-2.7981",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4711",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10933",
  "ui-addon-i18n": "static-1.11095",
  "ui-addon-react-router-dom": "static-1.9490",
  "ui-addon-upgrades": "static-9.17901",
  "ui-asset-management-lib": "static-1.10945",
  "ui-images": "static-2.1138",
  "UIComponents": "static-3.8350",
  "usage-tracker": "static-1.7281",
  "usage-tracker-container": "static-1.7271",
  "usage-tracker-core": "static-1.7131",
  "usage-tracker-public": "static-1.7092",
  "viral-links-lib": "static-1.6996",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3357",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3220",
  "quartz-webpack": "static-1.3167",
  "ai-components-ui-library": "static-1.8785",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4796",
  "foundations-theming": "static-1.4358",
  "quartz-auth": "static-1.618",
  "ui-business-units-lib": "static-1.8990",
  "usage-tracker-session-replay": "static-1.4967",
  "foundations-theming-base": "static-1.3343",
  "HeadJS": "static-2.740",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3070",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.37",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4268",
  "csstype": "static-1.50",
  "quartz-head": "static-1.608",
  "frontend-preferences-client": "static-1.7871",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3544",
  "persist-promise": "static-1.3652",
  "quartz-i18n": "static-1.618",
  "reporting-client-types": "static-1.2457",
  "foundations-components-legacy": "static-1.839",
  "hs-story-utils": "static-1.9372",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9827",
  "hubspotter-http": "static-1.4605",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7193",
  "crm-message-bus": "static-1.42828",
  "customer-data-filters-ui-msw-helpers": "static-1.21981",
  "customer-data-objects-ui-components": "static-1.12966",
  "customer-data-reference-ui-components": "static-1.13099",
  "customer-data-ui-utilities": "static-1.9770",
  "framework-builder-read-service-client": "static-1.3963",
  "framework-data-schema-quick-fetch": "static-1.6726",
  "framework-data-schema-resolvers": "static-1.6821",
  "inbound-db-properties-service-client": "static-1.3794",
  "multi-account-reference-resolvers": "static-1.922",
  "onboarding-tours": "static-1.16484",
  "reporting-datasets-permissions-lib": "static-1.13499",
  "ui-addon-teams": "static-1.21470",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68186",
  "customer-data-properties": "static-1.51344",
  "forms-ai-lib": "static-1.4223",
  "forms-utils-lib": "static-1.12466",
  "foundations-components-test-utils": "static-1.5297",
  "react-dnd-compat": "static-1.4564",
  "react-tinymce": "static-1.55074",
  "tinymce-config": "static-2.54200",
  "ui-gdpr-components": "static-1.10290",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4083",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1634",
  "ui-fonts": "static-1.665",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-routing": "static-1.373",
  "quartz-test": "static-1.618",
  "quartz-tracking": "static-1.322",
  "batch-promise": "static-1.1495",
  "external-options-client-types": "static-1.4112",
  "react-colorpicker": "static-2.10155",
  "copilot-toolkit": "static-1.10961",
  "data-quality-ui-library": "static-1.12726",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6407",
  "reporting-action-components": "static-1.41138",
  "reporting-filters": "static-1.161",
  "reporting-insights-lib": "static-1.1559",
  "reporting-plugins": "static-1.10195",
  "ui-addon-draggable-compat": "static-2.4199",
  "ui-addon-opt": "static-4.8319",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25196",
  "hubspot-apollo-client": "static-1.4821",
  "chirp-fetch": "static-1.1829",
  "sales-templates-service-types-lib": "static-1.4121",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5778",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4031",
  "nested-table": "static-1.169",
  "timezone-utils": "static-2.5188",
  "bender-build-tools": "static-1.3093",
  "chatspot-core": "static-1.21006",
  "bend-plugin-foundations-theming": "static-1.2841",
  "stylex": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.9825",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3750",
  "crm-pipelines-api-client-types": "static-1.4096",
  "multi-currency-client-types": "static-1.3645",
  "getting-started-shared-tasks": "static-1.18336",
  "growth-data-modal": "static-1.5333",
  "growth-onboarding-confetti": "static-1.3012",
  "growth-onboarding-next-action-utils": "static-1.1744",
  "navigation-components": "static-1.17821",
  "onboarding-tours-client": "static-1.4698",
  "onboarding-tours-utils": "static-1.550",
  "ui-shepherd-react": "static-3.10093",
  "ui-shepherd-tracker": "static-1.7474",
  "ui-universal-auth": "static-1.8902",
  "user-context": "static-1.5045",
  "cms-field-types": "static-1.4755",
  "content-icons-ui": "static-1.2211",
  "integrations-lib": "static-1.15927",
  "calling-global-api": "static-1.64303",
  "calling-internal-common": "static-1.31245",
  "calling-lifecycle-internal": "static-1.65685",
  "calling-lifecycle-messages": "static-1.57979",
  "commerce-products-lib": "static-1.9308",
  "crm-links": "static-1.6222",
  "customer-data-properties-shared-msw-handlers": "static-1.9154",
  "file-manager-components": "static-1.23450",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.85",
  "inbounddb-objects-service-types": "static-1.4177",
  "meetings-icalendar-utils-lib": "static-1.575",
  "object-builder-ui-client": "static-1.48542",
  "pipeline-validation-client-types": "static-1.3919",
  "property-value-citations": "static-1.1958",
  "pulse": "static-1.497",
  "smart-property-lib": "static-1.6650",
  "tiered-pricing": "static-1.1082",
  "ui-addon-iframeable": "static-1.8997",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19726",
  "tinymce-themes": "static-1.56170",
  "data-token-picker": "static-1.16298",
  "hub-http-contrib": "static-1.2984",
  "interframe": "static-3.4705",
  "tinymce-data": "static-1.40285",
  "tinymce-plugins": "static-1.57314",
  "ui-addon-sales-email": "static-1.5154",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5523",
  "magpie-types": "static-1.4983",
  "simple-logging-lib": "static-1.2993",
  "content-assistance-lib": "static-1.7660",
  "dashboard-lib": "static-1.81291",
  "ExportDialog": "static-6.10337",
  "hubspot-prosemirror": "static-1.18064",
  "hubspot-prosemirror-plugins": "static-1.18056",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8641",
  "campaign-roi-lib": "static-1.8896",
  "feedback-loader": "static-1.29190",
  "apollo-link-hub-http": "static-2.4593",
  "hubspot-apollo-cache": "static-1.280",
  "purchase-motions-api": "static-1.5781",
  "trials-service-types": "static-1.3847",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.116",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1858",
  "growth-onboarding-next-action-components": "static-1.1772",
  "user-context-client": "static-1.4554",
  "idb-keyval": "static-1.42",
  "nest": "static-1.168",
  "reactive-lib": "static-1.665",
  "unified-auth-core-lib": "static-1.697",
  "getting-started-shared-tasks-store": "static-1.17454",
  "integrations-error-boundary-lib": "static-1.13342",
  "integrations-tracking-lib": "static-1.5540",
  "native-integrations-shared-strings": "static-1.7728",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10316",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.416",
  "calling-error-reporting": "static-1.31251",
  "shared-worker-versioning": "static-1.10981",
  "calling-usage-tracker": "static-1.6486",
  "voice-sms-access-library": "static-1.749",
  "customer-data-tracking": "static-1.6830",
  "commerce-permissions": "static-1.709",
  "products-iframe-lib": "static-1.7758",
  "products-ui-components-shared-msw-handlers": "static-1.10209",
  "location-customization-utils-lib": "static-1.9070",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4098",
  "video-components-external": "static-1.11081",
  "video-data-lib": "static-1.34739",
  "directed-graph": "static-1.880",
  "event-emitter": "static-1.893",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.100",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9910",
  "fsm": "static-1.3677",
  "policy-lib": "static-1.6716",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9973",
  "navigation-messaging": "static-1.7148",
  "FileManagerLib": "static-1.39090",
  "NamespacedHubStyle": "static-2.9016",
  "FileManagerCore": "static-1.38949",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12327",
  "layout-dnd-utils": "static-1.11302",
  "react-codemirror": "static-1.10568",
  "ui-addon-emoji-picker": "static-1.9832",
  "ui-brand-identity-lib": "static-1.14976",
  "ui-addon-video-player": "static-1.8642",
  "ui-coaching-tips": "static-1.28380",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23366",
  "EmailSignatureEditor": "static-1.24245",
  "InboxConnectUtils": "static-4.14636",
  "universal-page-editor-lib": "static-1.2955",
  "google-sheets-integration-lib": "static-1.64",
  "microsoft-drive-integration-lib": "static-1.171",
  "calling-orchestration-schema": "static-1.35526",
  "sales-views-client-types": "static-1.4208",
  "crm-record-cards-service-types": "static-1.3564",
  "content-media-composition-data-lib": "static-1.12052",
  "content-media-compositions": "static-2.16059",
  "media-bridge-lib": "static-1.18822",
  "trellis-story-utils": "static-1.4460",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5825",
  "FileManagerImages": "static-1.36601",
  "video-components": "static-1.13084",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4476",
  "video-embed": "static-1.35573",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68261",
  "layout-data-lib": "static-1.9627",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6528",
  "commerce-tours-lib": "static-1.5984",
  "growth-onboarding-reliability": "static-1.5026",
  "sales-checkout-service-client": "static-1.3583",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21566",
  "sales-email-signature-service-client": "static-1.3786",
  "social-insights-client-types": "static-1.21920",
  "outpost": "static-1.4133",
  "advanced-menus-core": "static-1.15034",
  "advanced-menus-lib": "static-1.11988",
  "ui-memberships-settings-lib": "static-1.33885",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15033",
  "simple-menus-lib": "static-1.16550"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34365",
  "client-types": "/client-types/static-1.459",
  "documents-lib": "/documents-lib/static-1.34370",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2074",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5537",
  "hs-test-utils": "/hs-test-utils/static-1.7959",
  "hub-http": "/hub-http/static-1.6164",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11403",
  "I18n": "/I18n/static-7.1610",
  "jasmine-immutable": "/jasmine-immutable/static-1.2963",
  "jasmine-runner": "/jasmine-runner/static-1.6413",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6943",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16606",
  "reporting-data": "/reporting-data/static-1.67259",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9192",
  "reporting-visualizations": "/reporting-visualizations/static-1.59335",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4714",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5016",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2440",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39546",
  "customer-data-objects": "/customer-data-objects/static-1.7604",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8027",
  "data-fetching-client": "/data-fetching-client/static-1.9618",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4467",
  "flux-actions": "/flux-actions/static-1.329",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85676",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4664",
  "foundations-components": "/foundations-components/static-1.7814",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11711",
  "icons": "/icons/static-2.643",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7103",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3792",
  "property-translator": "/property-translator/static-1.5347",
  "quartz-config": "/quartz-config/static-1.721",
  "quartz-core": "/quartz-core/static-1.6162",
  "quick-fetch": "/quick-fetch/static-1.3870",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5297",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8114",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8037",
  "report-customization-components": "/report-customization-components/static-1.12973",
  "reporting-enablement": "/reporting-enablement/static-1.22690",
  "reporting-reports": "/reporting-reports/static-1.66937",
  "reporting-snowflake": "/reporting-snowflake/static-1.55877",
  "reporting-ui-components": "/reporting-ui-components/static-2.64530",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4590",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8880",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9155",
  "sanitize": "/sanitize/static-1.4417",
  "sanitize-text": "/sanitize-text/static-1.8087",
  "self-service-api": "/self-service-api/static-1.10190",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1689",
  "signup-constants": "/signup-constants/static-1.18737",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20747",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7981",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4711",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10933",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11095",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9490",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17901",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10945",
  "ui-images": "/ui-images/static-2.1138",
  "UIComponents": "/UIComponents/static-3.8350",
  "usage-tracker": "/usage-tracker/static-1.7281",
  "usage-tracker-container": "/usage-tracker-container/static-1.7271",
  "usage-tracker-core": "/usage-tracker-core/static-1.7131",
  "usage-tracker-public": "/usage-tracker-public/static-1.7092",
  "viral-links-lib": "/viral-links-lib/static-1.6996",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3357",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3220",
  "quartz-webpack": "/quartz-webpack/static-1.3167",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8785",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4796",
  "foundations-theming": "/foundations-theming/static-1.4358",
  "quartz-auth": "/quartz-auth/static-1.618",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8990",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4967",
  "foundations-theming-base": "/foundations-theming-base/static-1.3343",
  "HeadJS": "/HeadJS/static-2.740",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3070",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.37",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4268",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.608",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7871",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3544",
  "persist-promise": "/persist-promise/static-1.3652",
  "quartz-i18n": "/quartz-i18n/static-1.618",
  "reporting-client-types": "/reporting-client-types/static-1.2457",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.839",
  "hs-story-utils": "/hs-story-utils/static-1.9372",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9827",
  "hubspotter-http": "/hubspotter-http/static-1.4605",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7193",
  "crm-message-bus": "/crm-message-bus/static-1.42828",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21981",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12966",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13099",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9770",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3963",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6726",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6821",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3794",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.922",
  "onboarding-tours": "/onboarding-tours/static-1.16484",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13499",
  "ui-addon-teams": "/ui-addon-teams/static-1.21470",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68186",
  "customer-data-properties": "/customer-data-properties/static-1.51344",
  "forms-ai-lib": "/forms-ai-lib/static-1.4223",
  "forms-utils-lib": "/forms-utils-lib/static-1.12466",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5297",
  "react-dnd-compat": "/react-dnd-compat/static-1.4564",
  "react-tinymce": "/react-tinymce/static-1.55074",
  "tinymce-config": "/tinymce-config/static-2.54200",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10290",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4083",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1634",
  "ui-fonts": "/ui-fonts/static-1.665",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-routing": "/quartz-routing/static-1.373",
  "quartz-test": "/quartz-test/static-1.618",
  "quartz-tracking": "/quartz-tracking/static-1.322",
  "batch-promise": "/batch-promise/static-1.1495",
  "external-options-client-types": "/external-options-client-types/static-1.4112",
  "react-colorpicker": "/react-colorpicker/static-2.10155",
  "copilot-toolkit": "/copilot-toolkit/static-1.10961",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12726",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6407",
  "reporting-action-components": "/reporting-action-components/static-1.41138",
  "reporting-filters": "/reporting-filters/static-1.161",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1559",
  "reporting-plugins": "/reporting-plugins/static-1.10195",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4199",
  "ui-addon-opt": "/ui-addon-opt/static-4.8319",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25196",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4821",
  "chirp-fetch": "/chirp-fetch/static-1.1829",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4121",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5778",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4031",
  "nested-table": "/nested-table/static-1.169",
  "timezone-utils": "/timezone-utils/static-2.5188",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "chatspot-core": "/chatspot-core/static-1.21006",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2841",
  "stylex": "/stylex/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9825",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3750",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4096",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3645",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18336",
  "growth-data-modal": "/growth-data-modal/static-1.5333",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3012",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1744",
  "navigation-components": "/navigation-components/static-1.17821",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4698",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.550",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10093",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7474",
  "ui-universal-auth": "/ui-universal-auth/static-1.8902",
  "user-context": "/user-context/static-1.5045",
  "cms-field-types": "/cms-field-types/static-1.4755",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "integrations-lib": "/integrations-lib/static-1.15927",
  "calling-global-api": "/calling-global-api/static-1.64303",
  "calling-internal-common": "/calling-internal-common/static-1.31245",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65685",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57979",
  "commerce-products-lib": "/commerce-products-lib/static-1.9308",
  "crm-links": "/crm-links/static-1.6222",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9154",
  "file-manager-components": "/file-manager-components/static-1.23450",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.85",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4177",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.575",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48542",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3919",
  "property-value-citations": "/property-value-citations/static-1.1958",
  "pulse": "/pulse/static-1.497",
  "smart-property-lib": "/smart-property-lib/static-1.6650",
  "tiered-pricing": "/tiered-pricing/static-1.1082",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8997",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19726",
  "tinymce-themes": "/tinymce-themes/static-1.56170",
  "data-token-picker": "/data-token-picker/static-1.16298",
  "hub-http-contrib": "/hub-http-contrib/static-1.2984",
  "interframe": "/interframe/static-3.4705",
  "tinymce-data": "/tinymce-data/static-1.40285",
  "tinymce-plugins": "/tinymce-plugins/static-1.57314",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5154",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5523",
  "magpie-types": "/magpie-types/static-1.4983",
  "simple-logging-lib": "/simple-logging-lib/static-1.2993",
  "content-assistance-lib": "/content-assistance-lib/static-1.7660",
  "dashboard-lib": "/dashboard-lib/static-1.81291",
  "ExportDialog": "/ExportDialog/static-6.10337",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18064",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18056",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8641",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8896",
  "feedback-loader": "/feedback-loader/static-1.29190",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4593",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.280",
  "purchase-motions-api": "/purchase-motions-api/static-1.5781",
  "trials-service-types": "/trials-service-types/static-1.3847",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.116",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1858",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1772",
  "user-context-client": "/user-context-client/static-1.4554",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.168",
  "reactive-lib": "/reactive-lib/static-1.665",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.697",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17454",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13342",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5540",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7728",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10316",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.416",
  "calling-error-reporting": "/calling-error-reporting/static-1.31251",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10981",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6486",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.749",
  "customer-data-tracking": "/customer-data-tracking/static-1.6830",
  "commerce-permissions": "/commerce-permissions/static-1.709",
  "products-iframe-lib": "/products-iframe-lib/static-1.7758",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10209",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9070",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4098",
  "video-components-external": "/video-components-external/static-1.11081",
  "video-data-lib": "/video-data-lib/static-1.34739",
  "directed-graph": "/directed-graph/static-1.880",
  "event-emitter": "/event-emitter/static-1.893",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.100",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9910",
  "fsm": "/fsm/static-1.3677",
  "policy-lib": "/policy-lib/static-1.6716",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9973",
  "navigation-messaging": "/navigation-messaging/static-1.7148",
  "FileManagerLib": "/FileManagerLib/static-1.39090",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9016",
  "FileManagerCore": "/FileManagerCore/static-1.38949",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12327",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11302",
  "react-codemirror": "/react-codemirror/static-1.10568",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9832",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14976",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8642",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28380",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23366",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24245",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14636",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2955",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.64",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.171",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35526",
  "sales-views-client-types": "/sales-views-client-types/static-1.4208",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3564",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12052",
  "content-media-compositions": "/content-media-compositions/static-2.16059",
  "media-bridge-lib": "/media-bridge-lib/static-1.18822",
  "trellis-story-utils": "/trellis-story-utils/static-1.4460",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5825",
  "FileManagerImages": "/FileManagerImages/static-1.36601",
  "video-components": "/video-components/static-1.13084",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4476",
  "video-embed": "/video-embed/static-1.35573",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68261",
  "layout-data-lib": "/layout-data-lib/static-1.9627",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6528",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5984",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5026",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3583",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21566",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3786",
  "social-insights-client-types": "/social-insights-client-types/static-1.21920",
  "outpost": "/outpost/static-1.4133",
  "advanced-menus-core": "/advanced-menus-core/static-1.15034",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11988",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33885",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15033",
  "simple-menus-lib": "/simple-menus-lib/static-1.16550"
}
};
